import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.push_disabled')

const SUPPORT_EMAIL = 'merchant.support@thanx.com'

export interface ContactSupportLinkProps {
  // Matches the BodyText4 (14px) siblings in the page-level PushDisabledBanner
  // by default; the preview's PushDisabledNotice sits beside BodyText5 (12px)
  // siblings instead, so it opts into the smaller size (AI-938).
  small?: boolean
}

// A real anchor rather than a uikit Button: a mailto is a navigation, not an
// action, so the link role and native href behavior are the correct semantics.
const ContactSupportLink = ({ small = false }: ContactSupportLinkProps) => {
  const [css] = useStyletron()

  return (
    <a
      data-testid="lu-contact-support-link"
      href={`mailto:${SUPPORT_EMAIL}`}
      className={css({
        color: palette.belizeHole,
        fontSize: small ? '12px' : '14px',
        lineHeight: small ? '16px' : '20px',
        fontWeight: 700,
        textDecoration: 'none',
        ':hover': { textDecoration: 'underline' },
      })}
    >
      {t('contact_link')}
    </a>
  )
}

export default ContactSupportLink
